import React from 'react'
import BaseComponent from "../../pages/base/BaseComponent";
import PropTypes from "prop-types";
import {isEmpty} from "enqc-utilities/src/utils/Utilities";
import {Card, Col, Row} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label";
import {faCode} from "@fortawesome/free-solid-svg-icons";
import TextInput from "../input/TextInput";
import QRBarInput from "../input/QRBarInput";

export default class AssemblyComponentFormCard extends BaseComponent{

    constructor(props) {
        super(props);
        let {assembly} = this.props
        if(isEmpty(assembly)){
            assembly = {}
        }
        this.state = {
            assembly
        }
        let {serialComponent} = assembly
        if(!serialComponent){
            serialComponent = {}
        }
        let {components} = serialComponent
        if(!components){
            components = []
        }
        this.inputRefs = components.map(() => React.createRef());
    }

    componentDidMount() {
        super.componentDidMount();
        let {assembly} = this.state
        let {serialComponent} = assembly
        if(!serialComponent){
            serialComponent = {}
        }
        let {components} = serialComponent
        if(!components){
            components = []
        }
        this.inputRefs = components.map(() => React.createRef());
    }

    start(){
        setTimeout(()=>{
            let firstInput = this.inputRefs[0].current
            if(firstInput){
                firstInput.callFocus()
            }
        }, 300)
    }


    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let {assembly} = nextProps
            if(isEmpty(assembly)){
                assembly = {}
            }
            this.setState({assembly}, () => {
                let {serialComponent} = assembly
                if(!serialComponent){
                    serialComponent = {}
                }
                let {components} = serialComponent
                if(!components){
                    components = []
                }
            })
        }
    }

    render() {
        let {assembly} = this.state
        let {onPassed} = this.props
        onPassed = onPassed || (()=>{})
        if(isEmpty(assembly)){
            assembly = {}
        }
        let {serialComponent} = assembly
        if(!serialComponent){
            serialComponent = {}
        }
        let {components} = serialComponent
        if(!components){
            components = []
        }
        let {updateProperties} = this.props
        if(!updateProperties){
            updateProperties = () => {}
        }
        return (
            <Card border="light" className="bg-white shadow-sm mb-4">
                <Card.Header>
                    {label.SerialComponent}
                </Card.Header>
                <Card.Body>
                    <Row>
                        {
                            components.map((component, index)=>{
                                return (
                                    <Col key={index} xs={12} lg={6} className="text-left">
                                        <QRBarInput
                                            label={component.label}
                                            placeholder={" "}
                                            icon={faCode}
                                            value={component.value}
                                            ref={this.inputRefs[index]}
                                            onFilled={() => {
                                                if(index+1 < components.length){
                                                    if(this.inputRefs[index+1].current) {
                                                        this.inputRefs[index + 1].current.callFocus()
                                                    }
                                                }else{
                                                    onPassed()
                                                }
                                            }}
                                            onChange={(value) => {
                                                component.value = value
                                                components[index] = component
                                                serialComponent.components = components
                                                updateProperties('serialComponent', serialComponent)
                                            }}
                                        />
                                    </Col>
                                )
                            })
                        }
                    </Row>
                </Card.Body>
            </Card>
        );
    }

}

AssemblyComponentFormCard.propTypes = {
    assembly : PropTypes.any,
    updateProperties : PropTypes.func.isRequired,
    onPassed : PropTypes.func

}